import { BadgeColor } from '@billy/design-system'

import { BillStatus } from '../enums/billStatus'

export const billStatusToBadgeColor: Record<BillStatus, BadgeColor> = {
  [BillStatus.All]: 'neutral',
  [BillStatus.Draft]: 'accent',
  [BillStatus.Overdue]: 'danger',
  [BillStatus.Paid]: 'success',
  [BillStatus.PartiallyPaid]: 'warning',
  [BillStatus.Unpaid]: 'warning',
  [BillStatus.Voided]: 'neutral',
}
